import React from 'react';
import Button from '../../shared/Button';
import Input from '../../shared/Input';

const AddPlatformModal = ({
  isOpen,
  newPlatformName,
  setNewPlatformName,
  onAdd,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="p-4 sm:p-6">
          <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-3 sm:mb-4">
            Add Social Media Platform
          </h3>
          <p className="text-xs sm:text-sm text-gray-600 mb-4">
            Enter the name of the social media platform you want to add.
          </p>
          <div className="mb-4 sm:mb-6">
            <Input
              label="Platform Name"
              value={newPlatformName}
              onChange={(e) => setNewPlatformName(e.target.value)}
              placeholder="e.g., facebook, instagram, twitter"
              autoFocus
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onAdd();
                } else if (e.key === 'Escape') {
                  onCancel();
                }
              }}
            />
          </div>
          <div className="flex flex-col sm:flex-row justify-end space-y-2 sm:space-y-0 sm:space-x-3">
            <Button
              onClick={onCancel}
              variant="outline"
              className="w-full sm:w-auto"
            >
              Cancel
            </Button>
            <Button
              onClick={onAdd}
              disabled={!newPlatformName.trim()}
              className="w-full sm:w-auto"
            >
              Add Platform
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPlatformModal;


